import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from './store/slices/profileSlice';
import useMetaMask from './hooks/metamask';
import { logout } from './store/slices/authSlice';

function App() {
    const { connect, library, disconnect, isActive, account, active } = useMetaMask();
    const userLoggedIn = useSelector((state) => state.auth.userLoggedIn);
    const dispatch = useDispatch();

    useEffect(() => {
        if (userLoggedIn) {
            dispatch(getProfile());
        }
    }, [dispatch, userLoggedIn]);

    // useEffect(() => {
    //     if (!active) {
    //         dispatch(logout());
    //     }
    // }, [active, dispatch, library]);

    // useEffect(() => {
    //     if (!active) {
    //         dispatch(logout());
    //     }
    //     console.log('active', active);
    // }, [active, dispatch]);

    return <RouterProvider router={router} />;
}

export default App;
